class FostrForm extends HTMLElement {
  constructor () {
    super()

    this.form = this.querySelector('form')
    this.form.addEventListener('submit', this.onSubmit.bind(this))

    const submitEl = this.querySelector('[data-form-el="submit"]')
    submitEl.addEventListener('click', this.onSubmit.bind(this))

    this.inputs = [...this.form.querySelectorAll('input')]
    this.inputs.forEach(input => {
      input.addEventListener('focusout', this.onFocusValidation.bind(this))
    })

    this.selects = [...this.form.querySelectorAll('select')]
    this.selects.forEach(select => {
      select.addEventListener('change', this.selectValidation.bind(this))
    })
    this.bday = [...this.querySelectorAll('.birthday-options select')]
    this.age = ''
    this.isOfAge = false

    this.errors = []
  }

  validateForm (input) {
    if (input.hasAttribute('data-birthday')) {
      this.age = this.getAge(
        this.bday[2].value,
        this.bday[1].value,
        this.bday[0].value,
      )
    } else {
      this.isOfAge = true
    }

    const isMissMatch = this.form.querySelector(`#${input.id}-error-missMatch`)
    const isValueMissing = this.form.querySelector(`#${input.id}-error-valueMissing`)
    const isunderAge = this.form.querySelector(`#birtday-error-msg`)

    // Check if element is Input
    if (input.tagName === 'INPUT' && input.validity.patternMismatch) {
      if (isMissMatch) isMissMatch.style.display = 'block'
      if (isValueMissing) isValueMissing.style.display = 'none'
      this.errors.push({ message: `${input.name} value is invalid` })
      input.style.borderColor = 'red'
    } else if (input.validity.valueMissing) {
      if (isMissMatch) isMissMatch.style.display = 'none'
      this.errors.push({ message: `${input.name} value is missing` })
      if (isValueMissing) isValueMissing.style.display = 'block'
      input.style.borderColor = 'red'
    } else if (Number.isInteger(this.age) && this.age < 18) {
      if (isValueMissing) isValueMissing.style.display = 'none'
      input.style.borderColor = 'inherit'
      this.isOfAge = false
      this.errors.push({ message: 'customer is under age' })
      if (isunderAge) isunderAge.style.display = 'block'
    } else {
      if (isValueMissing) isValueMissing.style.display = 'none'
      if (isMissMatch) isMissMatch.style.display = 'none'
      if (isunderAge) isunderAge.style.display = 'none'
      input.style.borderColor = 'inherit'
      input.style.color = 'inherit'
      this.isOfAge = true
    }
  }

  getAge (...dateArray) {
    const dateString = dateArray.toString().replaceAll(',', '/')
    const today = new Date()
    const birthDate = new Date(dateString)
    let age = today.getFullYear() - birthDate.getFullYear()
    const m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  selectValidation (select) {
    this.validateForm(select.target)
  }

  onFocusValidation (e) {
    this.validateForm(e.target)
  }

  onSubmit (event) {
    this.inputs.forEach(input => {
      this.validateForm(input)
    })

    this.selects.forEach(select => {
      this.validateForm(select)
    })

    if (this.form.checkValidity() && this.isOfAge) {
      this.form.submit()
    } else {
      this.pushToDataLayer()
    }

    // console.log('hello', {
    //   isValid: this.form.checkValidity(),
    //   strings: this.form.validationMessage
    // });
  }

  pushToDataLayer () {
    if (this.errors.length <= 0) return

    const formName = this.dataset.gaName || this.id

    window.dataLayer.push({
      event: 'form_error',
      formError: {
        form_name: formName,
        error_messages: [
          this.errors,
        ],
      },
    })
  }
}

customElements.define('fostr-form', FostrForm)
